export default __webpack_public_path__ + "static/media/job-switching-arrow-left-skyblue.68641b1c.svg";